import { useMemo } from 'react';

import {
  DefaultYesNoFilterToolbarItemId,
  FilterToolbarItemId,
} from '../Filter.types';

export const useDefaultYesNoFilterValues = ({
  isReportsPage = false,
}: {
  isReportsPage?: boolean;
}) => {
  const shouldEnableEmptySelection = (
    filterId: FilterToolbarItemId
  ): boolean => {
    if (isReportsPage) {
      return true;
    }
    return !DefaultYesNoFilterToolbarItemId.includes(filterId);
  };

  const FILTER_DEFAULTS: Record<string, unknown> = useMemo(() => {
    const defaults: Record<string, unknown> = {};
    DefaultYesNoFilterToolbarItemId.forEach((filterId) => {
      defaults[filterId] = true;
    });
    return defaults;
  }, []);

  return {
    yesNoFilterDefaults: FILTER_DEFAULTS,
    shouldEnableEmptySelection,
  };
};
